import ApiAI from "../../../gd/api/ai/ai";


export default async function sendAIChatMessage(chatId: ID, message: string, agentId: ID | null = null) {

    try {
        return await ApiAI.sendMessage(chatId, {message, agentId}).promise()
    } catch (e) {
        console.error(e)
    }
}
